import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './components/home/Home';
import Chat from './components/chat/Chat';
import { IPublicClientApplication } from '@azure/msal-browser';
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react';
import { PageLayout } from './components/login/PageLayout';
import RequestInterceptor from './components/interceptor/RequestInterceptor';
import SignInPage from './components/login/SignInPage';
import ErrorPage from './components/pages/ErrorPage';
import ErrorBoundary from './components/errorboundary/ErrorBoundary';


type AppProps = {
  pca: IPublicClientApplication;
};

export const App: React.FunctionComponent<any> = ({ pca }: AppProps) => {
  return (
    <MsalProvider instance={pca}>
      <ErrorBoundary>
        <PageLayout>
          <AuthenticatedTemplate>
            <RequestInterceptor>
              <Switch>
                <Pages />
              </Switch>
            </RequestInterceptor>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <SignInPage />
          </UnauthenticatedTemplate>
        </PageLayout>
      </ErrorBoundary>
    </MsalProvider>

  );
};

function Pages() {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/chat" component={Chat} />
      <Route path="/ErrorPage" component={ErrorPage} />
    </Switch>
  );
}
